import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'

import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import ArrowDropDown from 'material-ui/svg-icons/navigation/arrow-drop-down';
import Search from 'material-ui/svg-icons/action/search';

import filtersActions from 'actions/filters'

import filters, {currentFilter} from  'selectors/filters'

let select = (state, props) => ({
	filters: filters[props.entity]
  , currentFilter: currentFilter(props.entity)(state)
})

class FiltersPicker extends Component {
	state = { isOpen: false }
	toggleMenu = () => {
		this.setState({
			isOpen: !this.state.isOpen
		})
	}
	render () {
		let {props} = this
		let {entity} = props
		return (
			<div
				style={{marginTop: "5px", height: "36px"}}
				className="filter-holder"
			>
				<div
					className="value"
					onClick={this.toggleMenu}
					style={{
						verticalAlign: "middle"
					, height: "inherit"
					, fontSize: "17px"
					, display: "inline-block"
					, marginLeft: "15px"
					, cursor: "pointer"
					}}
				>
					{props.currentFilter}
				</div>
				<IconMenu
					open={this.state.isOpen}
					onRequestChange={this.toggleMenu}
					iconButtonElement={
						<IconButton style={{paddingLeft: '0px', marginLeft: '-5px'}}>
							<ArrowDropDown	color='#FFF'/>
						</IconButton>
					}
					onItemTouchTap={(evt, item) => {
						props.PREDEFINED_FILTER_SET({
							  entity: props.entity
							, predefined: item.props.value
						})
					}}
				>
					{Object.keys(props.filters).map((filterName) =>
						<MenuItem
							key={filterName}
							value={filterName}
							primaryText={filterName}
						/>
					)}
				</IconMenu>
			</div>
		)
	}
}
export default connect(select, filtersActions)(FiltersPicker)



// WEBPACK FOOTER //
// ./src/components/FiltersPicker/index.js